import { Actor, SlidingState } from "../actor.js";
import { Layer } from "../tile.js";
import { actorDB, Decision } from "../const.js";
export class Animation extends Actor {
    getLayer() {
        return Layer.MOVABLE;
    }
    constructor(level, position, customData = "", direction) {
        var _a;
        super(level, position, customData, direction);
        this.animationCooldown = 16;
        this.animationLength = 16;
        this.moveSpeed = 0;
        if (customData === "extended") {
            this.animationCooldown += 3;
            this.animationLength += 3;
            this.animationCooldown--;
        }
        (_a = level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce(this.getSfx());
    }
    _internalDecide() {
        this.pendingDecision = this.moveDecision = Decision.NONE;
        this.slidingState = SlidingState.NONE;
        this.pendingDecisionLockedIn = false;
        this.animationCooldown--;
        if (!this.animationCooldown)
            this.destroy(null, null);
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    _internalDoCooldown() { }
    bumped(other, moveDirection) {
        if (this._internalBlocks(other, moveDirection) ||
            other instanceof Animation)
            return;
        this.destroy(null, null);
    }
}
Animation.blockTags = ["real-playable"];
export class Explosion extends Animation {
    constructor() {
        super(...arguments);
        this.id = "explosionAnim";
    }
    getSfx() {
        return "explosion";
    }
}
actorDB["explosionAnim"] = Explosion;
export class Splash extends Animation {
    constructor() {
        super(...arguments);
        this.id = "splashAnim";
    }
    getSfx() {
        return "splash";
    }
}
actorDB["splashAnim"] = Splash;
//# sourceMappingURL=animation.js.map